import React from "react";
import Navbars from "../Navbars";
import Sidebar from "../profile/Sidebar";
import MonitorRestrictedtable from "./MonitorRestrictedtable";
import search from "../assets/search.png";
import Businesspagination from "../Business/Businesspagination";

function MonitorRestricted() {
  return (
    <>
      <div
        className="conatiner-fluid"
        style={{
          backgroundColor: "#F5F5F5",
          position: "relative",
          height: "100vh",
        }}
      >
        <Navbars show="none" />
        <div className="d-flex gap-2 pe-3 main_div w-100">
          <Sidebar />
          <div className="table_outer ">
            <div className="d-flex gap-2 align-items-start table_outer_body">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <input type="radio" className="radio_one" />
                <input type="radio" className="radio_two " />
                <input type="radio" className="radio_two" />
                <input type="radio" className="radio_two" />
                <input type="radio" className="radio_two" />
              </div>
              <div
                className="inner_table_div   pt-2  mb-3 pb-4 pt-4 "
                style={{ marginLeft: "0px" }}
              >
                <div className="row ps-4  search_row">
                  <div className="col-lg-10 col-md-12 col-sm-12">
                    <div style={{ position: "relative" }}>
                      <input
                        placeholder="Search Business id, Business name, Zip code etc "
                        className="add_search business_search upper_input"
                      />
                      <img
                        src={search}
                        className="search_img"
                        style={{ top: "14px", left: "14px" }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-4 col-sm-4">
                    <button className="ad_btn business_add">
                      Add Business
                    </button>
                  </div>
                  <MonitorRestrictedtable />
                  <Businesspagination />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MonitorRestricted;
